import React from 'react'

import {Observer} from '../services/dom-observer'

// Use this hook to get a stable observer which hold a stable cleanup instance internally.
// This is especially useful if you have to recreate the observer in multiple places.
const useObserver = <A extends unknown[]>(createCallback: Observer<A>) => {
  const createCallbackRef = React.useRef<Observer<A>>(createCallback)
  createCallbackRef.current = createCallback

  const cleanupRef = React.useRef<() => void>(null)

  const cleanupObserver = React.useCallback(() => {
    if (cleanupRef.current) {
      cleanupRef.current()
      cleanupRef.current = null
    }
  }, [])

  const createObserver: Observer<A> = React.useCallback((...args: A) => {
    cleanupObserver()
    cleanupRef.current = createCallbackRef.current(...args)
    return cleanupObserver
  }, [])

  return {createObserver, cleanupObserver}
}

export default useObserver
